import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CircularProgress from "@mui/material/CircularProgress";
import { useTheme } from "@mui/material/styles";
import { LoadingPlaceholderParent, LoadingPlaceholderText } from "./LoadingPlaceholder.styles";
import { useTranslation } from "react-i18next";
export const LoadingPlaceholder = (props) => {
    var _a;
    const { t } = useTranslation(["common"]);
    const theme = useTheme();
    return (_jsxs(LoadingPlaceholderParent, { ...props, children: [_jsx(CircularProgress, { className: "loadingButtonCircularProgress", size: 48, sx: {
                    color: theme.palette.primary.main,
                } }), _jsx(LoadingPlaceholderText, { children: (_a = props.text) !== null && _a !== void 0 ? _a : t("Loading...") })] }));
};
